/* eslint-disable */
import actionTypes from '../constants/actionTypes'
import { setWatermarks, setDraftWatermarks } from '../slices/watermarkSlice'
import fetchHelper from '../utils/fetchHelper'
import { message, Modal } from 'antd'
import exceptionHelper, { Status } from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'
import { WM_STORAGE_KEYS } from '../constants/watermark'
import fetch from 'isomorphic-fetch'
import generateFullUrl from '../utils/generateFullUrl'

export function setEditorWatermark(data) {
  const updateTime = new Date().getTime()
  // 使用普通 JS 对象
  const plainData = typeof data === 'object' ? { ...data } : data
  if (plainData && typeof plainData === 'object') {
    plainData.update_time = String(updateTime)
  }
  return {
    type: actionTypes.SET_EDITOR_WATERMARK,
    data: plainData
  }
}

export function setEditorActiveItem(data) {
  return {
    type: actionTypes.SET_EDITOR_ACTIVE_ITEM,
    data
  }
}

export function setExpandedPanels(keys) {
  return {
    type: actionTypes.SET_EXPANDED_PANELS,
    data: keys
  }
}

export function setEditorGeoItemList(data) {
  return {
    type: actionTypes.SET_EDITOR_GEO_ITEMS_LIST,
    data
  }
}

export function setEditorCascadeItemsList(data) {
  return {
    type: actionTypes.SET_CASCADE_ITEMS_LIST,
    data
  }
}

// export function fetchAllGroupWatermarks(data) {
//   return (dispatch, getState) => {
//     dispatch({
//       type: actionTypes.SET_LOADING,
//       data: true
//     })
//     let config = {
//       url: __API_SERVER_HOST__ + '/web/workgroup/watermark/all',
//       arguments: {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(data)
//       }
//     }
//     return fetchHelper(dispatch, getState, config)
//       .then(exceptionHelper)
//       .then(data => {
//         let group = data.groups.find(group => group.groupID === getState().group.get('groupId'))
//           dispatch({
//             type: actionTypes.SET_WATERMARKS,
//             data: group ? group.watermarkList : []
//           })
//       })
//       .catch(err => {
//         captureFetchException(err, config)
//         return Promise.reject(null)
//       })
//       .finally(() => {
//         dispatch({
//           type: actionTypes.SET_LOADING,
//           data: false
//         })
//       })
//   }
// }
export function fetchGroupMarksContent(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/watermark/content/list',
      arguments: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => Promise.resolve(data))
  }
}

export function getWatermarkContentByWatermarkIds(watermarkIds) {
  return (dispatch, getState) => {
    // 将水印ID数组转换为API期望的格式
    const IDInfoList = watermarkIds.map((id) => ({ watermarkID: id }))

    let config = {
      url: __API_SERVER_HOST__ + '/web/group/watermark/content/list',
      arguments: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ IDInfoList })
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => Promise.resolve(data))
  }
}

// 新的 list 接口，不返回 content 字段，需要额外请求另一个接口获取 content 内容
// export function fetchGroupWaterMarksBaseList(data) {
//   return (dispatch, getState) => {
//     dispatch({
//       type: actionTypes.SET_LOADING,
//       data: true
//     })
//
//     let config = {
//       url: __API_SERVER_HOST__ + '/web/group/watermark/base/list',
//       arguments: {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(data)
//       }
//     }
//     return fetchHelper(dispatch, getState, config)
//       .then(exceptionHelper)
//       .then(async (data) => {
//         const watermarkListMap = new Map()
//         data.group.watermarkList.forEach(item => {
//           if (!watermarkListMap.get(item.id)) {
//             watermarkListMap.set(item.id, item)
//           }
//         })
//         const ids = Array.from(watermarkListMap.keys())
//         let idsGroup = [] // 20 个一组
//         for (let i = 0; i < ids.length; i = i + 20) {
//           idsGroup.push(ids.splice(i, i + 20))
//         }
//         const allIdsContents = await Promise.allSettled(idsGroup.map(item => {
//           return dispatch(
//             fetchGroupMarksContent({
//               IDInfoList: item
//             })
//           ).then(res => {
//             return Promise.resolve(res)
//           })
//         }))
//         allIdsContents.forEach(item => {
//           if (item.status !== 'fulfilled') return
//           item.value.contentList.forEach(contentItem => {
//             let obj = watermarkListMap.get(contentItem.watermarkID)
//             if (obj) {
//               obj.content = contentItem.content
//               obj.inviteID = contentItem.inviteID
//             }
//           })
//         })
//         data.group.watermarkList = Array.from(watermarkListMap.values())
//         dispatch({
//           type: actionTypes.SET_WATERMARKS,
//           data: data.group.watermarkList || []
//         })
//       })
//       .catch((err) => {
//         captureFetchException(err, config)
//         return Promise.reject(null)
//       })
//       .finally(() => {
//         dispatch({
//           type: actionTypes.SET_LOADING,
//           data: false
//         })
//       })
//   }
// }

export function fetchGroupWatermarks(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      // url: __API_SERVER_HOST__ + '/web/workgroup/group/watermark',
      url: __API_SERVER_HOST__ + '/web/group/watermark/base/list',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then(async (data) => {
        const watermarkListMap = new Map()
        data.group.watermarkList.forEach((item) => {
          // 建立 map 映射，方便后面补充 content 信息
          if (!watermarkListMap.get(item.id)) {
            watermarkListMap.set(item.id, item)
          }
        })
        const ids = Array.from(watermarkListMap.keys()) // 获取所有 水印 id
        let idsGroup: any[][] = []
        for (let i = 0; i < ids.length; i = i + 20) {
          // 20 个为一组
          idsGroup.push(ids.slice(i, i + 20))
        }
        // 循环 idsGroup，去请求接口，Promise.allSettled 接受数据，
        const allIdsContents = await Promise.allSettled(
          idsGroup.map((item) => {
            return dispatch(
              fetchGroupMarksContent({
                IDInfoList: item
              })
            ).then((res) => {
              return Promise.resolve(res)
            })
          })
        )
        // 在 Promise.allSettled 接受的数据中，向 watermarkListMap 中拼接 content 内容
        allIdsContents.forEach((item) => {
          if (item.status !== 'fulfilled') return
          item.value.contentList.forEach((contentItem) => {
            let obj = watermarkListMap.get(contentItem.watermarkID)
            if (obj) {
              obj.content = contentItem.content
              obj.inviteID = contentItem.inviteID
            }
          })
        })
        data.group.watermarkList = Array.from(watermarkListMap.values())
        return data
      })
      .then((data) => {
        const group = data.group
        dispatch(setWatermarks(group ? group.watermarkList : []))
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function updateOrNewWatermark(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/watermark/addedit',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        let data = result.data
        if (data.status === 0) {
          return Promise.resolve(result)
        } else if (data.status === -3) {
          localStorage.setItem('group_id', '')
          Modal.warning({
            title: '提示',
            content: '您已退出或被移出当前群',
            onOk: () => {
              window.location.href = '/'
            }
          })
        } else if (data.status === -10) {
          Modal.warning({
            title: '提示',
            content: '您没有操作权限'
          })
        } else if (data.status === -27) {
          Modal.warning({
            title: '发布失败',
            content: '内容大小超过上限，请适当删减预设选项内容',
            okText: '好的'
          })
        } else if (data.status === -23 || data.status === -24) {
          //水印被删除或已经被别人更新
          Modal.warning({
            title: '提示',
            content: '该水印已被其他管理员修改或删除，将返回列表',
            onOk: () => (window.location.href = '/watermark/list'),
            onCancel: () => (window.location.href = '/watermark/list')
          })
        } else if (data.status === Status.vipForbiden) {
          Modal.warning({
            title: '提示',
            content: '添加2个及以上团队水印为会员权益，您暂时无法享受此权益'
          })
        } else if (data.status === Status.svipForbiden) {
          Modal.warning({
            title: '提示',
            content:
              '添加8个及以上团队水印为团队“高级/超级会员”权益，您暂时无法享受此权益'
          })
        }
        return Promise.reject(result)
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function deleteWatermark(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/watermark/delete',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .then((data) => {
        message.success('操作成功！')
      })
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function watermarkGrantTips(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url:
        __API_SERVER_HOST__ + '/web/workgroup/watermark/department/select/tips',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function getDraftWatermarks(groupID) {
  const wmDraftsStr = localStorage.getItem(WM_STORAGE_KEYS.WM)
  const wmDraftGroupsStr = localStorage.getItem(WM_STORAGE_KEYS.WM_GROUPS)
  if (wmDraftsStr && wmDraftGroupsStr) {
    let wmDraft: any[] = [],
      wmDraftGroups: Record<string, any> = {}
    try {
      wmDraft = JSON.parse(wmDraftsStr)
      wmDraftGroups = JSON.parse(wmDraftGroupsStr)
      if (wmDraftGroups[groupID]) {
        const watermarkIDs = wmDraftGroups[groupID]
        return wmDraft.filter((wm) => watermarkIDs.includes(wm.id))
      }
    } catch (e) {
      return []
    }
  }
  return []
}

export function draftWatermarksAction(groupID) {
  const watermarks = getDraftWatermarks(groupID)
  return setDraftWatermarks(watermarks)
}

export function serverSideDecode(data) {
  return (dispatch, getState) => {
    let config = {
      url: __API_SERVER_HOST__ + '/web/photo/usercomment/decode',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        // return Promise.resolve(result.data)
        return Promise.resolve(decodeURIComponent(result.data))
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export function fetchWatermarkItemsList(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/watermark/item/all',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function saveWatermarkItemsList(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/watermark/item/save',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then(exceptionHelper)
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}
